<script lang="ts">
import { defineComponent } from "vue"
import LocationInviteConfirmed from "@/components/confirmation/LocationInviteConfirmed.vue"
import { ConfirmationActionType } from "@/types/data"
import locationInviteConfirmed from "@/components/confirmation/LocationInviteConfirmed.vue"

export default defineComponent({
    name: "ConfirmationProcessing",
    computed: {
        locationInviteConfirmed() {
            return locationInviteConfirmed
        },
    },
    components: { LocationInviteConfirmed },
    props: {
        id: { type: Number, required: true },
        action: { type: String, required: true },
    },
    data() {
        return {
            showLocationInviteConfirmedModal: false,
        }
    },
    mounted() {
        if (this.action === ConfirmationActionType.LOCATION_INVITE) {
            this.showLocationInviteConfirmedModal = true
        }
    },
    methods: {
        goToDashboard() {
            return this.$router.replace("/")
        },
    },
})
</script>

<template>
    <div>
        <LocationInviteConfirmed
            v-if="locationInviteConfirmed"
            :confirmationId="id"
            @close="goToDashboard"
        />
    </div>
</template>
